export default __webpack_public_path__ + "static/media/fiona-1.f2204912.gif";